import { IVeriTableHeader, IVeriTableRow } from "@directives/_veri/veriTable/veriTable.component";
import { DynamicReportService, ExportType } from "@reports/_services/dynamicReports.service";
import { LegacyExportService, IExportTableParams } from "@directives/_veri/export/legacyExport.service";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import copy from "fast-copy/dist/fast-copy.esm.js";
import { IDataDefinition, IReportDefinition } from "../../../main/components/reports/models/IReportDefinition";
import "./downloadAsReport.scss";

class DownloadAsReportComponentController implements angular.IComponentController {

    showDownloadOptions: boolean;
    downloadOptionsLeft: boolean = false;
    tooltipAlignRight: boolean = false;

    downloadOptions: string[] = [
        'pdf',
        'csv',
        'excel'
    ];

    headers: IVeriTableHeader[];
    rows: IVeriTableRow<any>[];

    exportTitle: string;

    definition: IDataDefinition;
    report: IReportDefinition;

    reportDefinition: IReportDefinition;

    //reportColumns: IColumnHeader[];

    loading: boolean;

    disabled: boolean;

    exportAsLandscape: boolean;

    showText: boolean;

    promiseArray: angular.IPromise<any>[];

    static $inject = ["$q", "exportService", "dynamicReportService", "translationService"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly exportService: LegacyExportService,
        private readonly dynamicReportService: DynamicReportService,
        private readonly translationService: TranslationService) {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (this.definition || this.report) {
            this.reportDefinition = copy(this.definition || this.report);
        }
    }

    onOptionClick(option: string): void {

        this.loading = true;
        var exportType = ExportType.PDF;

        switch (option) {
            case 'csv':
             exportType= ExportType.CSV;
                break;

            case 'excel':
                exportType = ExportType.Excel;
                break;
        }

        var params: IExportTableParams = {
            exportTitle: this.getExportTitle(),
            exportType: exportType,
            headers: this.headers,
            rows: this.rows,
            exportAsLandscape: this.exportAsLandscape,
            reportDefinition: this.reportDefinition
        };

        this.exportService.downloadOldTableAsReport(params).then(() => {
            this.loading = false;
        });
    }

    openDownloadOptions(): void {
        if (this.disabled) {
            return;
        }

        this.showDownloadOptions = !this.showDownloadOptions;
    }

    hideDownloadOptions(): void {
        this.showDownloadOptions = false;
    }

    // ---

    private getExportTitle(): string {
        return this.exportTitle ? this.exportTitle : this.translationService.t('downloadAsReport.export');
    }
}

export class DownloadAsReportComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            report: "<?",
            definition: "<?",
            headers: "<?",
            rows: "<?",
            exportTitle: "<?",
            disabled: "<?",
            exportAsLandscape: "<?",
            showText: "<?",
            downloadOptionsLeft: "<?",
            tooltipAlignRight: "<?"
        };

        this.controller = DownloadAsReportComponentController;
        this.template = require("./downloadAsReport.html");
    }
}
